import { render, staticRenderFns } from "./BillExcelIframe.vue?vue&type=template&id=da354d00&scoped=true"
import script from "./BillExcelIframe.vue?vue&type=script&lang=js"
export * from "./BillExcelIframe.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da354d00",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\JSH_ERP\\JSH_ERP\\mgerpweb\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('da354d00')) {
      api.createRecord('da354d00', component.options)
    } else {
      api.reload('da354d00', component.options)
    }
    module.hot.accept("./BillExcelIframe.vue?vue&type=template&id=da354d00&scoped=true", function () {
      api.rerender('da354d00', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/tools/BillExcelIframe.vue"
export default component.exports